import React, { useEffect, useState } from 'react';
import api from '../api';
import '../styles/EmbeddedEvents.css';

const EmbeddedEvents = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [limit, setLimit] = useState(50);
  const [error, setError] = useState(null);

  const loadEvents = async () => {
    setLoading(true);
    setError(null);
    try {
      const resp = await api.get(`/integration/meta-embedded-events/?limit=${limit}`);
      setEvents(resp.data.results || []);
    } catch (e) {
      setError(e.response?.data?.error || e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadEvents(); }, [limit]);

  return (
    <div className="embedded-events-container">
      <h1>📜 Eventos Embedded Signup</h1>
      <p>Monitoreo de mensajes <code>WA_EMBEDDED_SIGNUP</code> (éxito, cancelación, errores).</p>
      <div className="controls">
        <label>Mostrar últimos: </label>
        <select value={limit} onChange={e => setLimit(parseInt(e.target.value))}>
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
          <option value={150}>150</option>
          <option value={200}>200</option>
        </select>
        <button className="btn btn-secondary" onClick={loadEvents} disabled={loading}>🔄 Recargar</button>
      </div>
      {error && <div className="error-box">Error: {error}</div>}
      {loading ? <div>Cargando eventos...</div> : (
        <div className="events-table-wrapper">
          <table className="events-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Fecha</th>
                <th>Evento</th>
                <th>Éxito</th>
                <th>Paso</th>
                <th>Error</th>
                <th>Error ID</th>
                <th>Phone ID</th>
                <th>WABA ID</th>
                <th>Business ID</th>
                <th>Session ID</th>
              </tr>
            </thead>
            <tbody>
              {events.map(ev => (
                <tr key={ev.id} className={ev.success ? 'row-success' : (ev.error_message ? 'row-error' : '')}>
                  <td>{ev.id}</td>
                  <td>{new Date(ev.created_at).toLocaleString()}</td>
                  <td>{ev.event}</td>
                  <td>{ev.success ? '✅' : '❌'}</td>
                  <td>{ev.current_step || '-'}</td>
                  <td>{ev.error_message || '-'}</td>
                  <td>{ev.error_id || '-'}</td>
                  <td>{ev.phone_number_id || '-'}</td>
                  <td>{ev.waba_id || '-'}</td>
                  <td>{ev.business_id || '-'}</td>
                  <td>{ev.session_id || '-'}</td>
                </tr>
              ))}
              {events.length === 0 && !loading && (
                <tr><td colSpan={11} style={{textAlign:'center'}}>Sin eventos registrados</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
      <div className="legend">
        <span>✅ éxito</span> <span>❌ cancelado/error</span> <span className="legend-error">Fila roja = error detallado</span>
      </div>
    </div>
  );
};

export default EmbeddedEvents;
